import { Box, Theme, Typography } from "@mui/material";
import { TFunction } from "i18next";
import { SquareCheck } from "lucide-react";
import usersRoundOrange from "../../assets/users-round-orange.svg";
import usersRound from "../../assets/users-round.svg";
import { StatusBox } from "../../components/Commons/StatusBox.component";

export type AvailabilityInfoProps = {
  isEnrolled: boolean;
  hasAvailablePlaces: boolean;
  remainingPlaces: number;
  theme: Theme;
  t: TFunction;
  oneEditionIsEnrolled: boolean,
  editMode: boolean,
  selfEnrollment: boolean,

}

export const AvailabilityInfo = ({ 
  hasAvailablePlaces, 
  isEnrolled, 
  remainingPlaces, 
  theme, 
  t, 
  oneEditionIsEnrolled,
  editMode,
  selfEnrollment
}: AvailabilityInfoProps) => {


  const handleInfoStatus = () => {
    // se utente e' iscritto all'edizione corrente, a prescindere dalla edit mode
    if(isEnrolled) {
      return (
        <StatusBox
          backgroundColor={ theme.customColors.backgroundSecondaryComplete }
          border={ `0.06rem solid ${theme.customColors.borderSecondaryComplete}` }
          icon={ <SquareCheck size={ "1rem" } /> }
          color={ theme.customColors.textTag }
          label={ t("Iscrizione effettuata") }
        />
      );
    }

    // se utente NON e' iscritto all'edizione corrente, e l'edizione e' di tipo top-down -> non e' permesso all'utente di gestire l'iscrizione
    if(!selfEnrollment) {
      return <></>;
    }

    // se utente NON e' iscritto all'edizione corrente ma ad un'altra dell'attivita', puo' auto iscriversi e la edit mode e' disattivata
    if(oneEditionIsEnrolled && !editMode) {
      return <></>;
    }

    // in tutti gli altri casi, quando ci sono posti disponibili
    return hasAvailablePlaces ? (
      <>
        <img 
          src={ usersRound } 
          alt="users-logo-icon" 
          width={ 16 } 
          height={ 16 } 
          style={ { marginRight: "8px" } } 
        />
        <Typography 
          sx={ {
            color: theme.customColors.accentVariantA, fontSize: "0.75rem"
          } }
        >
          { remainingPlaces } { "" }  { remainingPlaces === 1 ? 
            t("edition_remaining_place") : t("edition_remaining_places") }
        </Typography>
      </>
    ) : (
      <>
        <img 
          src={ usersRoundOrange } 
          alt="users-logo-icon" 
          width={ 16 } 
          height={ 16 } 
          style={ { marginRight: "8px" } } 
        />
        <Typography
          sx={ { 
            color: theme.customColors.accentVariantC, 
            fontSize: "0.75rem" 
          } }
        >
          { t("no_available_places") }
        </Typography>
      </>
    ); 

  };

  
  return (
    <Box sx={ { alignItems: "center", display: "flex" } }>
      { handleInfoStatus() }
    </Box>
  );};
